var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.errorsData),function(error){return (_vm.errorsData)?_c('div',{staticClass:"access-block__desc access-block__desc--warn-active"},[_vm._v(" "+_vm._s(error)+" ")]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }